import { render } from "./GravatarChooser.vue?vue&type=template&id=c7ae1cdc&scoped=true"
import script from "./GravatarChooser.vue?vue&type=script&lang=js"
export * from "./GravatarChooser.vue?vue&type=script&lang=js"

import "./GravatarChooser.vue?vue&type=style&index=0&id=c7ae1cdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7ae1cdc"]])

export default __exports__